import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MatAutoSearchComponent } from "../../mat-auto-search/mat-auto-search.component";
import { MatAutoSearchService } from "../../mat-auto-search/mat-auto-search.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ApiRoutes } from "../../../../services/apiroutes";
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-super-location-dialog',
    templateUrl: './super-location-dialog.component.html',
    styleUrls: ['./super-location-dialog.component.scss']
})
export class SuperLocationDialogComponent extends MatAutoSearchComponent implements OnInit {

    // @Input()
    ports = [];

    @Output()
    portsChange = new EventEmitter();

    showSelectedList = false;
    regionList = [];
    countryList = [];

    constructor(
        autoSearchService: MatAutoSearchService,
        private snackBar: MatSnackBar,
        public authService: AuthService,
        public dialogRef: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public inputData: any
    ) {
        super(autoSearchService);
        // this.defaultFontSize= this.authService.defaultFontSize;
    }

    override idField = null;

    override displayField = 'name';

    override placeholder = 'Select Port/Country/Region';

    override _listUrl = ApiRoutes.DepotMaster + 'super_location/?search=::search::&type=region,country,port';

    override get data() {
        return this._data;
    }

    override set data(val) {
        this._data = null;
        this.errors = [];
        this.onChange(null);
        this.appendPorts(val.ports);
    }

    override ngOnInit() {
        this.dataStatement = "Obtaining Locations.";
        super.ngOnInit();

        if (this.inputData.portsData !== null) {
            this.ports = this.inputData.portsData;
        }
    }
    ngAfterViewInit() {
        document.addEventListener('keydown', (event: KeyboardEvent) => {
            //   console.log("this is what I got in event",event)

            if (event.code === "Escape") {
                this.dialogRef.close();
            }
        });
    }

    appendPorts(ports) {

        // snackbar with message "No ports found in this region/country"
        let new_ports = ports.filter(item => !this.isPortAlreadyAdded(item))
        if (new_ports == 0) {
            this.snackBar.open('No new ports found in this region/country', 'Close', {
                duration: 2000,
                verticalPosition: 'top',
            });

        }

        for (let port of new_ports) {
            this.ports.unshift(port);
        }
        console.table(this.ports);
        this.portsChange.emit(this.ports);
    }

    isPortAlreadyAdded(port) {
        return this.ports.find(existing_port => this.isPortEqual(port, existing_port))
    }

    isPortEqual(port1, port2) {
        return port1.id === port2.id;
    }

    regionClicked(added, region) {
        if (added) {
            this.appendPorts(region.ports);
        } else {
            for (let port of region.ports) {
                this.removePort(port);
            }
        }
    }

    portClicked(added, port) {
        if (added) {
            this.appendPorts([port]);
        } else {
            this.removePort(port);
        }
    }

    isRegionSelected(region) {

        if (this.ports.length == 0) {
            return false;
        }

        if (region.ports.length == 0) {
            return false;
        }

        return region.ports.every((value) => this.isPortAlreadyAdded(value));
    }

    isRegionIndeterminate(region) {
        if (this.ports.length == 0) {
            return false;
        }

        if (region.ports.length == 0) {
            return false;
        }

        let full_length = region.ports.length;
        let filtered_length = region.ports.filter((value) => this.isPortAlreadyAdded(value)).length

        return filtered_length > 0 && filtered_length < full_length;
    }

    removePort(port) {
        this.ports = this.ports.filter(existing_port => !this.isPortEqual(port, existing_port));
        this.portsChange.emit(this.ports);
    }

    closeDialog() {
        this.dialogRef.close(this.ports);
    }

    searchPorts(event) {
        this.dataStatement = "Looking for Locations.";
        this.searchText.next(event);
    }

    selectedPortsForRegion(region) {
        const set2Ids = new Set(region.ports.map(item => item.id));
        return this.ports.filter(item => set2Ids.has(item.id)).length;
    }
}
